import { PersonalizationTokenRoleName } from "models/personalizationToken";
import type { IssueType } from "models/issue";

export const USER_ROLE_NAMES: PersonalizationTokenRoleName[] = [
  "recipient",
  "assignee",
  "new_hire",
  "manager",
  "buddy",
  "people_team_contact",
];

/** Human-readable short labels for each issue type. */
export const ISSUE_TYPE_LABELS: Record<IssueType, string> = {
  missing_message_service_user: "Slack account missing",
  missing_email: "Email missing",
  unassigned_role: "Role unassigned",
  missing_channel_membership: "Channel access missing",
  missing_message_service: "Slack not connected",
  missing_attribute: "Missing info",
  undelivered: "Undelivered action",
  unauthorized_message_sender: "Unauthorized sender",
  deactivated_sender: "Deactivated sender",
};
